import { render, staticRenderFns } from "./InvoicesAddRX.vue?vue&type=template&id=c8e855c4&scoped=true&"
import script from "./InvoicesAddRX.vue?vue&type=script&lang=js&"
export * from "./InvoicesAddRX.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesAddRX.vue?vue&type=style&index=0&id=c8e855c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e855c4",
  null
  
)

export default component.exports